import { makeSvgImage } from '../../../../components/SvgImage/index.ts';

export const Cloud1 = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" width="83" height="26" fill="none">
    <path
      fill="#fff"
      fillOpacity=".6"
      fillRule="evenodd"
      d="M14.399 12.684a5.398 5.398 0 0 1-.423-2.075C13.976 4.749 23.88 0 36.099 0c10.136 0 18.68 3.268 21.298 7.727a38.472 38.472 0 0 1 6.13-.481c10.647 0 19.278 4.17 19.278 9.315 0 4.914-7.873 8.939-17.856 9.29v.024h-1.123a42.37 42.37 0 0 1-.597 0H13.845C6.198 25.875 0 22.921 0 19.277c0-3.644 6.198-6.598 13.843-6.598a30 30 0 0 1 .555.005Z"
      clipRule="evenodd"
    />
  </svg>,
);
